let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eGv20"), load("84SAq"), load("5ZMuJ"), load("8myCk"), load("jXIn9"), load("aZinD"), load("8m15Y")]).then(() => parcelRequire('jsyvA'));